import { useAppSelector } from "../../store/storeHooks"
import { selectEffectiveCompanyId, selectEffectiveUserType } from "../../context/contextSelectors"
import { UserType } from "../../login/loginTypes"

export function useCurrentCompany() {
    const userType = useAppSelector(selectEffectiveUserType)
    const companyId = useAppSelector(selectEffectiveCompanyId)

    if (userType !== UserType.COMPANY) {
        throw new Error("Invalid state: not currently acting as a supplier")
    }
    if (!companyId) {
        throw new Error("Invalid state: effective supplier id not found")
    }

    return {
        companyId
    }
}
